import { render, staticRenderFns } from "./RelatorioLegenda.vue?vue&type=template&id=166533d5&scoped=true"
import script from "./RelatorioLegenda.vue?vue&type=script&lang=js"
export * from "./RelatorioLegenda.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLegenda.vue?vue&type=style&index=0&id=166533d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166533d5",
  null
  
)

export default component.exports